import React, { useState } from 'react';
import { ConversionTable, GradientInput, InputLabel, InputWrapper, InputGroup, TabContent } from '../../pages/tools/ToolsPage.components';
import { formatNumber } from './conversionUtils';

const TemperatureConverter: React.FC = () => {
    const [celsius, setCelsius] = useState('15');
    const [fahrenheit, setFahrenheit] = useState('59');

    const handleCelsiusChange = (value: string) => {
        setCelsius(value);
        if (value === '') {
            setFahrenheit('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const fahrenheitValue = (numValue * 9) / 5 + 32;
            setFahrenheit(formatNumber(fahrenheitValue, 2));
        }
    };

    const handleFahrenheitChange = (value: string) => {
        setFahrenheit(value);
        if (value === '') {
            setCelsius('');
            return;
        }
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            const celsiusValue = ((numValue - 32) * 5) / 9;
            setCelsius(formatNumber(celsiusValue, 2));
        }
    };

    return (
        <TabContent>
            <ConversionTable>
                <thead>
                    <tr>
                        <th>Temperature</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Celsius:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput id="celsius" type="text" value={celsius} onChange={(e) => handleCelsiusChange(e.target.value)} />
                                    <InputLabel htmlFor="celsius">°C</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                    <tr>
                        <td>Fahrenheit:</td>
                        <td>
                            <InputWrapper>
                                <InputGroup>
                                    <GradientInput
                                        id="fahrenheit"
                                        type="text"
                                        value={fahrenheit}
                                        onChange={(e) => handleFahrenheitChange(e.target.value)}
                                    />
                                    <InputLabel htmlFor="fahrenheit">°F</InputLabel>
                                </InputGroup>
                            </InputWrapper>
                        </td>
                    </tr>
                </tbody>
            </ConversionTable>
        </TabContent>
    );
};

export default TemperatureConverter;
